import { render, staticRenderFns } from "./FuncoesEspecificas.vue?vue&type=template&id=0bf74ca0"
import script from "./FuncoesEspecificas.vue?vue&type=script&lang=js"
export * from "./FuncoesEspecificas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports